import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { FileDown, Receipt } from 'lucide-react';

const DownloadBillDialog = ({ open, onClose, onDownload, billNumber }) => {
    const handleDownload = (includeGst) => {
        onDownload(includeGst);
        onClose();
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <FileDown className="h-5 w-5 text-sky-600" />
                        Download Invoice
                    </DialogTitle>
                    <DialogDescription>
                        Choose how you want to download invoice {billNumber}
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-3 py-4">
                    <Button
                        onClick={() => handleDownload(true)}
                        variant="outline"
                        className="h-auto py-4 px-6 flex flex-col items-start gap-2 border-2 hover:bg-slate-50"
                    >
                        <div className="flex items-center gap-2 w-full">
                            <Receipt className="h-5 w-5" />
                            <span className="font-semibold">With GST</span>
                        </div>
                        <span className="text-xs text-muted-foreground font-normal">
                            Download invoice including GST calculations
                        </span>
                    </Button>

                    <Button
                        onClick={() => handleDownload(false)}
                        variant="outline"
                        className="h-auto py-4 px-6 flex flex-col items-start gap-2 border-2 hover:bg-slate-50"
                    >
                        <div className="flex items-center gap-2 w-full">
                            <Receipt className="h-5 w-5" />
                            <span className="font-semibold">Without GST</span>
                        </div>
                        <span className="text-xs text-muted-foreground font-normal">
                            Download invoice excluding GST calculations
                        </span>
                    </Button>
                </div>

                <DialogFooter>
                    <Button type="button" variant="ghost" onClick={onClose}>
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DownloadBillDialog;
